import { fetchTags } from './tags';
import { fetchRefData } from './ref-data';
import { fetchStyles } from './styles';
import { fetchMetrics } from './metrics';
import { fetchSurveys } from './surveys';
import { fetchFeeds } from './feeds';
import { fetchRealTimeVotes } from './real-time-votes';
import { fetchRewards } from './rewards';
export { default as ApiUtils } from './api-utils';

export default {
  fetchFeeds,
  fetchTags,
  fetchRefData,
  fetchStyles,
  fetchMetrics,
  fetchSurveys,
  fetchRealTimeVotes,
  fetchRewards,
};
